import type { Location } from 'react-router-dom'
import type { Nil } from '@pbt/pbt-ui-components'

import type { MenuItem } from './menuItem'

export const getSelectedItem = (
  item: MenuItem[] | MenuItem,
  location: Location,
): MenuItem | Nil => {
  const children = Array.isArray(item) ? item : item.children
  const menuItem = item as MenuItem

  return children
    ? children.find((child) => getSelectedItem(child, location))
    : menuItem?.url &&
        (menuItem.url.includes('/analytics/')
          ? location.pathname === menuItem.url
          : location.pathname.indexOf(menuItem.url) === 0)
      ? menuItem
      : null
}
